import React, { useState, useEffect, useRef } from "react";
import {
  PencilAltIcon,
  UserGroupIcon,
  CalendarIcon,
  MenuIcon,
  XIcon,
} from "@heroicons/react/solid";
import PropTypes from "prop-types";
import { Link, useHistory, useLocation } from "react-router-dom";
import { connect } from "react-redux";

import FeedbackModal from "./HeaderBar/FeedbackModal";
import LogoutConfirmModal from "./HeaderBar/LogoutConfirmModal";
import { classNames } from "../utils";

import { getIsSomeObjectPending } from "../selectors/sync";

const LinkItem = ({ to, children }) => (
  <Link
    className="w-full justify-center inline-block text-center pt-1 pb-1"
    to={to}
  >
    {children}
  </Link>
);

LinkItem.propTypes = {
  to: PropTypes.string,
  children: PropTypes.any,
};

const PROFILE_DROPDOWN_LINKS = [
  { name: "Settings", link: "/settings/" },
  { name: "Help", link: "/help/" },
];

const NAV_LINKS = [
  { link: "/h/list", icon: PencilAltIcon, otherMatch: "/h/" },
  { link: "/t", icon: CalendarIcon },
  { link: "/c", icon: UserGroupIcon },
];
function MobileNavbar({ user, someObjectPending }) {
  const history = useHistory();
  const location = useLocation();
  const menuRef = useRef(null);
  const menuButtonRef = useRef(null);
  const [openMenu, setOpenMenu] = useState(false);
  const [openFeedbackModal, setOpenFeedbackModal] = useState(false);
  const [openLogoutConfirmationModal, setOpenLogoutConfirmationModal] =
    useState(false);
  function onSignOut() {
    if (someObjectPending) {
      setOpenLogoutConfirmationModal(true);
    } else {
      history.push("/logout");
    }
  }

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        !menuButtonRef.current.contains(event.target)
      ) {
        setOpenMenu(false);
      }
    }
    document.addEventListener("mouseup", handleClickOutside);
    return () => {
      document.removeEventListener("mouseup", handleClickOutside);
    };
  }, [menuRef]);

  return (
    <>
      <section
        id="bottom-navigation"
        className="block lg:hidden fixed inset-x-0 bottom-0 z-10 bg-white shadow py-1 mobile-nav-container"
      >
        {openMenu && (
          <div
            ref={menuRef}
            className="px-2 pb-1 text-right border-b border-gray-200"
          >
            {PROFILE_DROPDOWN_LINKS.map((item) => (
              <Link
                onClick={() => {
                  setOpenMenu(false);
                }}
                key={item.name}
                to={item.link}
                className="block px-3 py-2 rounded-md text-base font-medium cursor-pointer"
              >
                {item.name}
              </Link>
            ))}
            <div
              onClick={() => {
                setOpenMenu(false);
                setOpenFeedbackModal(true);
              }}
              className="block px-3 py-3 rounded-md text-base font-medium cursor-pointer"
            >
              Feedback
            </div>
            <div
              onClick={() => {
                onSignOut();
              }}
              className="block px-3 py-3 rounded-md text-base font-medium cursor-pointer"
            >
              Sign Out
            </div>
          </div>
        )}
        {openFeedbackModal && (
          <FeedbackModal
            closeFeedbackModal={() => {
              setOpenFeedbackModal(false);
            }}
          />
        )}
        {openLogoutConfirmationModal && (
          <LogoutConfirmModal
            closeConfirmModal={() => setOpenLogoutConfirmationModal(false)}
          />
        )}
        <div id="mobileTabs" className="flex justify-between">
          {NAV_LINKS.map((linkItem, key) => {
            return (
              <LinkItem key={key} to={linkItem.link}>
                <linkItem.icon
                  className={classNames(
                    location.pathname.includes(linkItem.link) ||
                      location.pathname.includes(linkItem.otherMatch)
                      ? "text-gray-700"
                      : "text-gray-400",
                    "m-auto h-6 w-6 "
                  )}
                />
              </LinkItem>
            );
          })}
          <div
            ref={menuButtonRef}
            onClick={() => setOpenMenu(!openMenu)}
            className="w-full focus:text-teal-500 hover:text-teal-500 justify-center inline-block text-center pt-1 pb-1"
          >
            {openMenu ? (
              <XIcon className="h-6 w-6 text-gray-400 m-auto" />
            ) : (
              <MenuIcon className="h-6 w-6 text-gray-400 m-auto" />
            )}
          </div>
        </div>
      </section>
    </>
  );
}

MobileNavbar.propTypes = {
  user: PropTypes.object.isRequired,
  someObjectPending: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  someObjectPending: getIsSomeObjectPending(state),
});

export default connect(mapStateToProps)(MobileNavbar);
